import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AjaxService } from './ajax.service';
import { EXPO_MOVEIN_DEF } from './account-api.constants';
import { ViewScopeService } from './view-scope.service';


@Injectable({
	providedIn: 'root'
})
export class ExportMovinService {
	constructor(
		private ajaxService: AjaxService,
		private viewScopeService: ViewScopeService
	) 
	{ }

	public exportMovein(listOfJournals: number[], isAttempt: 0|1 = 0): Observable<any> 
	{
		return this.ajaxService.addObjectData(this.ajaxService.getBaseOfApi() + EXPO_MOVEIN_DEF, this.createData(listOfJournals, isAttempt));
	}

	private createData(listOfJournals: number[], isAttempt: 0|1): any 
	{
		return {
			List_of_Values: JSON.stringify(listOfJournals), // "[156,157]"
			IsValue: 0, // 1 = list of FileRecID, 0 = list of Journal IDs
			IsTmpMoveIn: isAttempt, // If value is 1, file won't be deleted.
			CustomerRecID: this.viewScopeService.getCurrentCustomer(),
			UserRecID: this.viewScopeService.getCurrentOpertaingUserId().toString()
		};
	}
}
